/**
 * Scale drop form – template sync effect (sync selected senders to active template)
 * For Media Devoted | Created By Ciro Autiero
 */

import { useEffect, useRef, useState } from 'react';
import { useGatewaySenderTemplates, useUpdateGatewaySenderTemplate } from '@/hooks';

export function useScaleDropFormTemplateSync(
  countryKey: string,
  routeId: number,
  selectedSenderNames: string[],
) {
  const { data: senderTemplates = [] } = useGatewaySenderTemplates(countryKey, routeId);
  const updateTemplate = useUpdateGatewaySenderTemplate(countryKey, routeId);
  const [activeTemplateId, setActiveTemplateId] = useState<string | null>(null);
  const lastSyncedRef = useRef<string>('');

  useEffect(() => setActiveTemplateId(null), [countryKey, routeId]);

  useEffect(() => {
    if (!activeTemplateId || selectedSenderNames.length === 0) return;
    const sorted = [...selectedSenderNames].sort();
    const key = JSON.stringify(sorted);
    if (key === lastSyncedRef.current) return;
    const t = senderTemplates.find((x) => x.id === activeTemplateId);
    if (!t) return;
    const tm = setTimeout(() => {
      const firstName = selectedSenderNames[0] ?? 'Template';
      const name = selectedSenderNames.length > 1 ? `${firstName} +${selectedSenderNames.length - 1}` : firstName;
      updateTemplate.mutate({ id: activeTemplateId, senderNames: selectedSenderNames, name });
      lastSyncedRef.current = key;
    }, 400);
    return () => clearTimeout(tm);
  }, [activeTemplateId, selectedSenderNames, senderTemplates, updateTemplate]);

  return { activeTemplateId, setActiveTemplateId, senderTemplates, updateTemplate, lastSyncedRef };
}
